import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';
import { libraryComponents } from '../../../../constants/UiBuilderConst';

const PageBuilderLibrary = (props) => {
  const { setIsAddLine } = props;
  const [expandTab, setExpandTab] = useState(0);

  const handleAccordianChange = (tab) => (event, isExpanded) => {
    setExpandTab(isExpanded ? tab : -1);
  };

  const onDragStart = (e, component) => {
    e.dataTransfer.setData('component', JSON.stringify(component));
    setIsAddLine(true);
  };

  return (
    <div className='row'>
      <div className='library-accordian'>
        {libraryComponents.map((item, key) => (
          <Accordion
            key={item.id}
            expanded={expandTab === key}
            onChange={handleAccordianChange(key)}
            className='accordion-with-border'
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={item.id + 'content'}
              id={item.id}
            >
              <div>
                <img
                  alt='activeimage'
                  src={expandTab === key ? item.imageActive : item.imageInactive}
                />
              </div>
              <div className='ml-10'>{item.header}</div>
            </AccordionSummary>
            <AccordionDetails>
              <div className='w-100'>
                <div className='row'>
                  {item.components.map((component, key) => (
                    <div key={key} className='col-md-6'>
                      <div
                        className='library-component-box p-2 d-flex flex-column  align-items-center justify-content-center'
                        draggable
                        onDragStart={(e) => onDragStart(e, component)}
                        onDragEnd={() => setIsAddLine(false)}
                      >
                        <img src={component.image} alt={component.title} />
                        <div className='library-component-box-title mt-2'>{component.title}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default PageBuilderLibrary;
